<template>
  <div class="log-item-detail">
    <p>ID <code>{{modelValue._id}}</code></p>
    <p>ID utente <code>user_id</code>: <a :class="`cursor-pointer${isChanged('user_id') ? ' font-weight-bold':''}`" @click="$router.push(`/users/${modelValue.user_id}`)">{{displayUserId(modelValue.user_id)}}</a></p>
    <p>ID Prodotto <code>product_id</code>: <a :class="`cursor-pointer${isChanged('product_id') ? ' font-weight-bold':''}`" @click="goToProductPage(modelValue.product_id)">{{displayProductId(modelValue.product_id)}}</a></p>
    <p>SKU prodotto <code>product_sku</code>: <span :class="`${isChanged('product_sku') ? ' font-weight-bold':''}`">{{modelValue.product_sku}}</span></p>

    <div :style="`font-size: 12px; ${!modelValue.seats || !modelValue.seats.length ? 'border-bottom: 1px solid eee' : ''}`">Sedute <code>seats</code>: <span v-if="!modelValue.seats || !modelValue.seats.length" :class="`${isChanged('seats') ? ' font-weight-bold':''}`">-</span></div>
    <product-seats-card v-for="(seat, i) in modelValue.seats" :key="i" :model-value="seat" :is-changed="isChanged('seats')"></product-seats-card>
    <p>Tipologia prodotto <code>type</code>: <span :class="`${isChanged('type') ? ' font-weight-bold':''}`">{{getProductTypeLabel(modelValue.type)}}</span></p>
    <p>Tipologia sedute <code>seats_types</code>: <span :class="`${isChanged('seats_types') ? ' font-weight-bold':''}`">{{modelValue.seats_types.map(sTypeName).join(', ')}}</span></p>
    <p>N° sedute <code>num_seats</code>: <span :class="`${isChanged('num_seats') ? ' font-weight-bold':''}`">{{modelValue.num_seats}}</span></p>
    <p>Lezioni in corso <code>ongoing_lessons</code>: <span :class="`${isChanged('ongoing_lessons') ? ' font-weight-bold':''}`">{{modelValue.ongoing_lessons ? modelValue.ongoing_lessons.join(', ') : '-'}}</span></p>
    <p>Lezioni in fatte <code>done_lessons</code>: <span :class="`${isChanged('done_lessons') ? ' font-weight-bold':''}`">{{modelValue.done_lessons ? modelValue.done_lessons.join(', ') : '-'}}</span></p>
    <p>Consumato <code>consumed</code>: <span :class="`${isChanged('consumed') ? ' font-weight-bold':''}`">{{modelValue.consumed ? 'Sì' : 'No'}}</span></p>
    <p>Data <code>date</code>: <span :class="`${isChanged('date') ? ' font-weight-bold':''}`">{{formatDateTime(modelValue.date)}}</span></p>
    <p>Scadenza <code>expiration</code>: <span :class="`${isChanged('expiration') ? ' font-weight-bold':''}`">{{modelValue.expiration ? formatDateTime(modelValue.expiration) : '-'}}</span></p>
  </div>
</template>

<script lang="ts">
import {defineComponent, inject, type PropType} from 'vue'
import {type ProductType, type Purchase, SeatsType, type TopGymLogChangedField, type UserSeat} from "@/models.ts";
import type {Globals} from "@/plugins/globals.ts";
import utils from "@/utils";
import {useRouter} from "vue-router";
import ProductSeatsCard from "@/components/ProductSeatsCard.vue";

export default defineComponent({
  name: "UserSeatCard",
  components: {ProductSeatsCard},
  props : {
    modelValue : {
      type : Object as PropType<Purchase>,
      required : true
    },
    changedFields : {
      type : Array as PropType<TopGymLogChangedField[]>
    }
  },
  setup(props, ctx) {

    const router = useRouter()
    const globals = inject('globals') as Globals

    return {
      displayUserId(id:string):string {
        const u = globals.users.value.find(u => u._id === id)
        return u ? `[${u._id}] ${u.surname} ${u.name} (${u.email})` : `[${id}] - utente eliminato`
      },
      displayProductId(id?:string):string {
        if(!id) return '-'
        const p = globals.products.value.find(p => p._id === id)
        return p ? `[${p._id}] ${p.title.it}` : `[${id}] - prodotto eliminato`
      },
      sTypeName(s:SeatsType):string {
        switch (s) {
          case SeatsType.exp:
            return "TopGym experience";
          case SeatsType.corsi:
            return "Sala corsi";
          case SeatsType.opengym:
            return "Open gym";
          case SeatsType.vacu:
            return "Vacu";
        }
        return s
      },
      async goToProductPage(id?:string) {
        if(!id) return
        const p = globals.products.value.find(p => p._id === id)
        if(!p) return
        await router.push(`/kits/${p.kit_id}/products/${id}`)
      },
      isChanged(attr:keyof Purchase):boolean {
        if(!props.changedFields || !props.changedFields.length) return false
        const i = props.changedFields.find(p => p.name === attr)
        return i !== undefined
      },
      getProductTypeLabel(tp:ProductType):string {
        switch (tp) {
          case "mixed":
            return "sedute miste";
          case "distinct":
            return "sedute distinte";
          case "video":
            return "video lezioni";

        }
      },
      formatDateTime : utils.formatDateTime,
    }
  }
})
</script>

<style scoped>
.log-item-detail p {
  font-size: 12px;
  margin-top: 0;
  padding-bottom: 4px;
  margin-bottom: 4px;
  border-bottom: 1px solid #eee;
}

.log-item-detail p:has(> .font-weight-bold) {
  color: #dd0000;
}
.log-item-detail code {
  background-color: #dddddd;
  border-radius: 4px;
  padding: 2px 4px;
}
.log-item-detail a{
  text-decoration: underline;
  color: #f39530;
}
</style>